import axiosInstance from "./axiosInstance";

const I18nBackend = {
  type: "backend",

  init(_services, backendOptions) {
    this.options = backendOptions || {};
  },

  read(language, namespace, callback) {
    axiosInstance
      .get("/api/i18n/translations", {
        params: { lang: language, namespace },
      })
      .then(({ data }) => {
        callback(null, data.data);
      })
      .catch((err) => {
        callback(err, false);
      });
  },
};

export default I18nBackend;
